<template>
    <div>
        <v-row v-if="additionalLinks" dense>
            <v-col :cols="lCols">Additional links</v-col>
            <v-col :cols="rCols">
                <div v-for="link in additionalLinks" :key="link">
                    <a
                        :href="link"
                        target="_blank"
                        v-html="makeAdditionalLinkHtml(link)"
                    ></a>
                </div>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col :cols="lCols"> Library version </v-col>
            <v-col :cols="rCols">
                {{ version }}
            </v-col>
        </v-row>
        <v-row dense>
            <v-col :cols="lCols"> Created by </v-col>
            <v-col :cols="rCols">
                {{ createdBy }}
            </v-col>
        </v-row>
        <v-row v-if="additionalAuthors" dense>
            <v-col :cols="lCols">Additional authors</v-col>
            <v-col :cols="rCols">
                <div v-for="author in additionalAuthors" :key="author">
                    {{ author }}
                </div>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col :cols="lCols"> Last updated </v-col>
            <v-col :cols="rCols">
                {{ lastUpdate }}
            </v-col>
        </v-row>
        <v-row dense>
            <v-col :cols="lCols"> Calc ID </v-col>
            <v-col :cols="rCols">
                {{ calcId }}
            </v-col>
        </v-row>
        <v-row v-if="persistentCalcId" dense>
            <v-col :cols="lCols"> Persistent Calc ID </v-col>
            <v-col :cols="rCols">
                {{ persistentCalcId }}
            </v-col>
        </v-row>
    </div>
</template>
<script setup>
import { ref } from 'vue'

const props = defineProps({
    version: { type: String, default: '' },
    createdBy: { type: String, default: '' },
    lastUpdate: { type: String, default: '' },
    calcId: { type: String, default: '' },
    persistentCalcId: { type: String, default: null },
    additionalLinks: { type: Array, default: null },
    additionalAuthors: { type: Array, default: null },
})

const lCols = ref(3)
const rCols = ref(9)

function makeAdditionalLinkHtml(link) {
    if (link) {
        return link.replaceAll('/', '<wbr />/')
    }
    return ''
}
</script>
